import React, {useState} from 'react';

function AssetGroupSidebarTree({
    items = [],
    selectedItemId,
    onSelect,
    depth = 0,
}) {
    const [expanded, setExpanded] = useState(() => {
        const initial = {};
        items.forEach((item) => {
            if (item.children?.length) {
                initial[item.id] = true;
            }
        });
        return initial;
    });

    const toggleExpand = (id) => {
        setExpanded((prev) => ({...prev, [id]: !prev[id]}));
    };

    if (!items.length) {
        return null;
    }

    return (
        <ul className="sidebar-flat-list sidebar-flat-list--tree">
            {items.map((item) => {
                const hasChildren = item.children?.length > 0;
                const isExpanded = expanded[item.id];
                const isSelected = selectedItemId === item.id;

                return (
                    <li key={item.id} className="sidebar-flat-list--tree__node">
                        <div
                            className={`sidebar-flat-list__item ${isSelected ? "is-selected" : ""}`}
                            style={{paddingLeft: `${depth * 14 + 4}px`}}
                        >
                            {hasChildren ? (
                                <button
                                    type="button"
                                    className="sidebar-flat-list__toggle"
                                    aria-expanded={isExpanded}
                                    onClick={() => toggleExpand(item.id)}
                                >
                                    {isExpanded ? "▾" : "▸"}
                                </button>
                            ) : (
                                <span className="sidebar-flat-list__toggle sidebar-flat-list__toggle--spacer" />
                            )}
                            <button
                                type="button"
                                className="sidebar-flat-list__label"
                                onClick={() => onSelect(item)}
                            >
                                <span className="sidebar-flat-list__name">{item.name}</span>
                            </button>
                        </div>
                        {hasChildren && isExpanded && (
                            <AssetGroupSidebarTree
                                items={item.children}
                                selectedItemId={selectedItemId}
                                onSelect={onSelect}
                                depth={depth + 1}
                            />
                        )}
                    </li>
                );
            })}
        </ul>
    );
}

export default AssetGroupSidebarTree;
